// Pin the category belt to the top of the viewport once the page scrolls
// past it (the header itself no longer sticks - the belt is the persistent
// navigation on both the homepage and collection pages).
//
// The belt's natural offset is measured from a permanent 1px sentinel kept in
// normal flow right above it, so the measurement is valid whether the belt is
// in flow or fixed. A placeholder keeps the layout from jumping while fixed.
(function () {
  var belt = document.querySelector('.collection-filter__belt');
  if (!belt) return;

  // Permanent in-flow probe: the belt itself leaves the flow while fixed and
  // the placeholder only exists while stuck, so neither can be measured
  // reliably at all times. 1px tall (IntersectionObserver needs a box; Dawn's
  // base.css hides empty divs, hence the inline display) with a negative
  // margin so it adds nothing to the layout.
  var sentinel = document.createElement('div');
  sentinel.style.cssText = 'display:block;height:1px;margin-bottom:-1px;visibility:hidden;';
  belt.parentNode.insertBefore(sentinel, belt);

  var placeholder = null;

  var naturalTop = function () {
    return sentinel.getBoundingClientRect().top + window.scrollY;
  };

  // Dawn's reveal-on-scroll leaves any section that a restored scroll
  // position skipped over in its pre-animation state (scroll-trigger--
  // offscreen, opacity 0.01) until it "enters" the viewport - which a
  // container that sits above the restored viewport never does. If such a
  // container wraps the belt, the pinned belt paints at 1% opacity: belt
  // gone, free-shipping strip floating at the belt's height over the cards.
  // The belt's own markup no longer sits under a reveal wrapper
  // (main-collection-banner.liquid), but keep the nav immune by
  // construction: while the belt should be pinned, reveal any ancestor the
  // animation left hidden.
  var unveil = function () {
    var el = belt.parentElement;
    while (el && el !== document.documentElement) {
      if (el.classList.contains('scroll-trigger--offscreen')) {
        el.classList.remove('scroll-trigger--offscreen');
      }
      el = el.parentElement;
    }
  };

  var update = function () {
    var shouldStick = window.scrollY > naturalTop();
    if (shouldStick) unveil();
    if (shouldStick && !placeholder) {
      placeholder = document.createElement('div');
      // Dawn's base.css hides empty divs (div:empty { display: none }),
      // which zeroed this spacer and made stick/unstick oscillate on every
      // scroll event - the inline display wins over that rule.
      placeholder.style.display = 'block';
      placeholder.style.height = belt.offsetHeight + 'px';
      belt.parentNode.insertBefore(placeholder, belt);
      belt.classList.add('is-stuck');
    } else if (!shouldStick && placeholder) {
      belt.classList.remove('is-stuck');
      placeholder.remove();
      placeholder = null;
    } else if (placeholder) {
      // Rotation/resize while stuck: keep the spacer matching the belt.
      var h = belt.offsetHeight + 'px';
      if (placeholder.style.height !== h) placeholder.style.height = h;
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  // The scroll listener alone is not enough: this script runs (defer) BEFORE
  // the browser restores a saved scroll position, and Safari can restore it
  // WITHOUT firing a scroll event - on reload, on back/forward (bfcache or
  // not), and again LATE, after images load and the page grows tall enough to
  // scroll that far. The old fix re-checked on a list of timeouts after
  // load/pageshow, which lost whenever the restore came later than the last
  // timeout (slow networks - the symptom was a missing belt with the product
  // cards starting underneath the free-shipping strip).
  //
  // The sentinel observer closes that hole for good: it is geometry-driven,
  // so ANY change in where the belt's spot sits relative to the viewport -
  // scroll restoration, late image layout shifts, bfcache restores - fires a
  // reconcile, no matter what caused it or when it happens.
  if (typeof IntersectionObserver === 'function') {
    new IntersectionObserver(update).observe(sentinel);
  }

  // Belt-and-suspenders for engines where the observer is quantized or
  // coalesced: cheap explicit re-checks on the lifecycle edges known to move
  // the scroll position without events.
  var recheck = function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(update);
    });
    [0, 120, 400, 1000].forEach(function (delay) {
      setTimeout(update, delay);
    });
  };
  window.addEventListener('load', recheck);
  window.addEventListener('pageshow', recheck);
  window.addEventListener('popstate', recheck);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recheck();
  });
  recheck();

  // A late image decode can change the belt's own height without moving the
  // sentinel. Re-evaluate when its measured size settles as well.
  if (typeof ResizeObserver === 'function') {
    new ResizeObserver(update).observe(belt);
  }

  // Edge fades: on the homepage the <collection-filter> element toggles
  // .at-start/.at-end as the cards row scrolls; on collection pages the belt
  // renders outside that element, freezing the server-rendered classes and
  // slicing cards at the edges with no fade. Wire the same updater here.
  var cards = belt.querySelector('.collection-filter__cards');
  if (cards && !belt.closest('collection-filter')) {
    var updateFade = function () {
      var atStart = cards.scrollLeft <= 1;
      var atEnd = cards.scrollLeft + cards.clientWidth >= cards.scrollWidth - 1;
      belt.classList.toggle('at-start', atStart);
      belt.classList.toggle('at-end', atEnd);
    };
    cards.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    updateFade();
  }
})();
